/* eslint-disable no-var */
<template>
  <div>
    <Breadcrumb :title="`Buyout Detail: ${PartnerName}`"></Breadcrumb>

    <div class="form-row">
      <div class="form-group col-md-12">
        <label
          class="section-title"
          style="margin:0px;padding:0px;!important"
        >Termination Date : {{displayFields.TerminationDate}}</label>
        <br />
      </div>
    </div>

    <BaseSearchBar :config="SearchBuyout" @keyupSearch="filterGrid"></BaseSearchBar>
    <BaseToolBar :config="BuyoutDetailToolBarConfig" @buttonClicked="BuyoutDetailToolBarClick"></BaseToolBar>
    <BaseGrid
      :mode="'inline'"
      :excelExport="excelExport"
      :config="ProgramDetailGridConfig"
      :colorizeColumn="true"
      :dropdownOptions="dropdownTreasury"
      @calculatedColumn="calculatedColumn"
      :data="ProgramDetailGridData"
      :colorizeInputColumns="['UnitsToBeRetained','Treasury']"
    ></BaseGrid>

    <!-- <BuyoutDocumentDropoffForm
      ref="buyoutDocument"
      :docModalConfig="docModalConfig"
      :filterCondition="filterCondition"
      :transactionRecord="selectedBuyout"
    ></BuyoutDocumentDropoffForm>-->
    <!-- <br>
     <router-link class="btn btn-primary" :to="'/event/buyout'" tag="button" exact>Back to Buyout</router-link>
    <br>-->
  </div>
</template>

<script>
// Breadcrumb implementation
import Breadcrumb from "@/components/layout/Breadcrumb.vue";
import $ from "jquery";

// Base Searchbar Implementation
import BaseSearchBar from "@/components/base/BaseSearchBar.vue";
import funcUtil from "@/services/funcUtil.js";
import deepGroupBy from "@/services/groupByUtil.js";

// Base Toolbar Implementation
import BaseToolBar from "@/components/base/BaseToolbar.vue";
import toolbarUtility from "@/services/toolbarUtility.js";
import {
  ProgramDetailGridConfig,
  BuyoutDetailToolBarConfig
} from "./BuyoutEventConfig.js";

import BaseBusinessEventRunningTotal from "@/models/BaseBusinessEventRunningTotal.js";
import BaseUnitClass from "@/models/BaseModelUnitClass.js";
import BaseModelBuyout from "@/models/BaseModelBuyout.js";
import BaseModelInputControl from "@/models/BaseModelInputControl.js";

// Base Grid Implementation
import BaseGrid from "@/components/base/BaseGrid.vue";
import apiUtil from "@/services/apiUtil.js";
import _ from "lodash";
import { mapActions, mapGetters } from "vuex";
import { isNullOrUndefined, isString, isNumber } from "util";
import linq from "linq";
import BaseModelTransactionLog from "@/models/BaseModelTransactionLog.js";
import moment from "moment";

import BusinessEventApprovalMixin from "@/mixins/BusinessEventApprovalMixin.js";
//import BuyoutDocumentDropoffForm from "@/components/forms/BuyoutDocumentDropoffForm.vue";
import BaseModelProgram from "@/models/BaseModelProgram.js";
import BaseModelPartner from "@/models/BaseModelPartner.js";
import BaseModelIssuance from "@/models/BaseModelIssuance.js";

export default {
  name: "BuyoutEventDetail",
  mixins: [apiUtil, funcUtil, toolbarUtility, BusinessEventApprovalMixin],
  components: {
    Breadcrumb,
    BaseSearchBar,
    BaseToolBar,
    BaseGrid
    //BuyoutDocumentDropoffForm
  },

  data: function() {
    return {
      // Base Grid implementation
      ProgramDetailGridConfig: ProgramDetailGridConfig,
      buyoutProgramDetailGridId: ProgramDetailGridConfig.grid.gridId,
      partnerId: this.$route.params.partnerId,
      PartnerName: "",
      BuyoutDetailMasterData: [],

      // Base Toolbar with button implementation
      BuyoutDetailToolBarConfig: BuyoutDetailToolBarConfig,

      // Base Searchbar implementation
      SearchBuyout: {
        SearchData: ""
      },
      BaseModelInputControl: BaseModelInputControl,

      BusinessEventRunningTotalAPIData: [],
      UnitClassAPIData: [],

      ProgramDetailGridData: [],
      dropdownTreasury: {},
      BaseModelBuyout: BaseModelBuyout,
      saveBuyoutData: [],

      BaseModelProgram: BaseModelProgram,
      BaseModelPartner: BaseModelPartner,
      BaseModelIssuance: BaseModelIssuance,
      displayFields: {
        TerminationDate: ""
      }
      // Document dropoff modal
      // docModalConfig: {
      //   modalName: "Buyout Documents",
      //   modalIdandRef: "docModal",
      //   isFooter: false
      // },
      // // Filter condition for Document dropoff modal
      // filterCondition: {
      //   filter: "",
      //   limit: 500
      // },
      // selectedBuyout:{},
    };
  },

  computed: {
    ...mapGetters("getModule", [
      "withFilter",
      "getAllItemFilter",
      "getLocalInputControls",
      "GetValueByKey"
    ])
  },

  beforeRouteUpdate(to, from, next) {
    this.partnerId = to.params.partnerId;
    if (this.partnerId) {
    } else {
    }
    next();
  },

  mounted() {
    const self = this;
    // Tool bar grid setting
    // self._loadGridSettings(self.buyoutProgramDetailGridId);

    self.getInputControls();
    self.displayFields.TerminationDate = self.GetValueByKey(
      "BuyoutTerminationDate"
    );
    if (self.displayFields.TerminationDate != "") {
      let date = new Date(self.displayFields.TerminationDate);
      self.displayFields.TerminationDate = moment(
        String(date.toISOString())
      ).format("MM/DD/YYYY");
    } else {
      self.backtoPartner();
    }

    //Bind databound event to grid
    var grid = $("#buyoutProgramDetailGrid").data("kendoGrid");
    grid.bind("dataBound", self.UpdateBuyoutDetailMasterData);
    self.getBaseGridData();
  },

  methods: {
    async getBaseGridData() {
      const self = this;
      await self.getProgramGridData();
      self._loadGridSettings(self.buyoutProgramDetailGridId);
      self.gridColumnNonEditable();
    },

    gridColumnNonEditable: function() {
      var grid = $("#buyoutProgramDetailGrid").data("kendoGrid");

      if (grid.tbody.find("tr").length) {
        grid.tbody.find("tr").each(function() {
          // console.log($(this));

          let dataItem = grid.dataItem(this);
          if (
            dataItem.WorkflowStatus == "Approved" ||
            dataItem.WorkflowStatus == "Processing"
          ) {
            if ($(this).find("td").length) {
              // console.log($(this));

              $(this)
                .find("td")
                .each(function(index) {
                  if (index > 1) {
                    $(this).addClass("disableRowCells");
                  }
                });
            }
          }
        });
      }
    },

    ...mapActions("postModule", [
      "CreateAllItems",
      "deleteAllItem",
      "UpdateAllItems",
      "CreateJoinedItems"
    ]),

    backtoPartner: function() {
      this.$router.push("/event/buyout");
    },

    getInputControls() {
      const self = this;
      let response = self.getLocalInputControls(
        self.BaseModelInputControl.list
      );
      self.dropdownTreasury["Treasury"] = response["Treasury"];
    },

    calculatedColumn: function(e) {
      if (e.values.hasOwnProperty("UnitsToBeRetained")) {
        if (
          e.values.UnitsToBeRetained <=
          e.model.AwardedUnits - e.model.VestedUnits
        ) {
          //After UnitsToBeReatined edit- search in grid --Start
          let i = e.sender._data.findIndex(obj => {
            return obj.uid == e.model.uid && obj.Id == e.model.Id;
          });
          console.log("rerset", i);

          //After UnitsToBeReatined edit- search in grid --End

          //Total Units to be retained
          var TotalUnitsToBeRetained = e.container
            .closest("TR")
            .find(".TotalUnitsToBeRetained");
          let calcTotalUnitsToBeRetained =
            e.values.UnitsToBeRetained + e.model.VestedUnits;
          TotalUnitsToBeRetained.html(calcTotalUnitsToBeRetained);
          e.sender._data[i].TotalUnitsToBeRetained = calcTotalUnitsToBeRetained;

          //Units To Be Forfeited
          var UnitsToBeForfeited = e.container
            .closest("TR")
            .find(".UnitsToBeForfeited");
          let calcUnitsToBeForfeited =
            e.model.AwardedUnits - calcTotalUnitsToBeRetained;
          UnitsToBeForfeited.html(calcUnitsToBeForfeited);
          e.sender._data[i].UnitsToBeForfeited = calcUnitsToBeForfeited;

          //Amount Payable
          var AmountPayable = e.container.closest("TR").find(".AmountPayable");
          let calcAmountPayable =
            e.model.UnitPrice * calcTotalUnitsToBeRetained;
          AmountPayable.html(calcAmountPayable);
          e.sender._data[i].AmountPayable = calcAmountPayable;

          //Amount Receivable
          var AmountReceivable = e.container
            .closest("TR")
            .find(".AmountReceivable");
          let calcAmountReceivable = e.model.UnitPrice * calcUnitsToBeForfeited;
          AmountReceivable.html(calcAmountReceivable);
          e.sender._data[i].AmountReceivable = calcAmountReceivable;

          //Amount Paid (or) Paid for Units
          var AmountPaid = e.container.closest("TR").find(".AmountPaid");
          let calcAmountPaid =
            e.model.AmountPaidForProgram *
            (e.model.AwardedUnits / e.model.SumofAwardedUnits);
          AmountPaid.html(calcAmountPaid);
          e.sender._data[i].AmountPaid = calcAmountPaid;

          //Buyout
          var Buyout = e.container.closest("TR").find(".Buyout");
          let calcBuyout =
            calcAmountPaid - calcAmountPayable > 0
              ? calcAmountPaid - calcAmountPayable
              : 0;
          Buyout.html(calcBuyout); // have to update with AmountPaid variable
          e.sender._data[i].Buyout = calcBuyout;

          //Amount owed to partnership
          var AmountOwedToPartnership = e.container
            .closest("TR")
            .find(".AmountOwedToPartnership");
          let calcAmountOwedToPartnership =
            calcAmountPayable - calcAmountPaid > 0
              ? calcAmountPayable - calcAmountPaid
              : 0;
          AmountOwedToPartnership.html(calcAmountOwedToPartnership); // have to update with AmountPaid variable
          e.sender._data[
            i
          ].AmountOwedToPartnership = calcAmountOwedToPartnership;

          //Contribution relief
          var ContributionRelief = e.container
            .closest("TR")
            .find(".ContributionRelief");
          let calcContributionRelief = calcAmountReceivable - calcBuyout;
          ContributionRelief.html(calcContributionRelief);
          e.sender._data[i].ContributionRelief = calcContributionRelief;

          //Net payout
          var NetPayout = e.container.closest("TR").find(".NetPayout");
          let calcNetPayout = calcBuyout - calcAmountOwedToPartnership;
          NetPayout.html(calcNetPayout);
          e.sender._data[i].NetPayout = calcNetPayout;
        } else {
          this._AlertPopup(
            "Please enter valid data in UnitstobeRetained Column. Eg: (Units to be Retained should be Greaterthan or equal to Zero and Units to be Retained should be lesserthan or equal to the difference of AwardedUnits and VestedUnits)",
            "warning"
          );
        }
      }
    },

    getDateDiffinDays: function(date1, date2) {
      let dt1 = new Date(date1);
      let dt2 = new Date(date2);
      return Math.floor(
        (Date.UTC(dt1.getFullYear(), dt1.getMonth(), dt1.getDate()) -
          Date.UTC(dt2.getFullYear(), dt2.getMonth(), dt2.getDate())) /
          (1000 * 60 * 60 * 24)
      );
    }, 

    async approveBuyout() {
      const self = this;
      let partnerTermDate = self.GetValueByKey("BuyoutTerminationDate");
      let initialAwardDate = new Date();

      const grid = $("#buyoutProgramDetailGrid").data("kendoGrid");
      self.saveBuyoutData = [];
      let TransactionData = [];

      if (grid.select().length > 0) {
        grid.select().each(function() {
          const grdDataItem = grid.dataItem(this);

          if (grdDataItem.WorkflowStatus == "Pending") {
            let localBuyoutData = {};

            localBuyoutData.PartnerId = grdDataItem.PartnerId;
            localBuyoutData.ProgramId = grdDataItem.ProgramId;
            localBuyoutData.ProgramTitle = grdDataItem.ProgramName;

            localBuyoutData.UnitType = grdDataItem.UnitType;
            localBuyoutData.VestingType = grdDataItem.VestingType;
            localBuyoutData.UnitClass = grdDataItem.UnitClass;
            localBuyoutData.UnitPool = grdDataItem.UnitPool;
            localBuyoutData.UnitPrice = grdDataItem.UnitPrice;

            localBuyoutData.Status = "Processing";
            localBuyoutData.ConvertToTreasury = grdDataItem.Treasury;

            // let programData = self.withFilter()
            let programFilterQuery = {
              filter: "Id eq " + grdDataItem.ProgramId
            };
            var selectedProgram = self.withFilter(
              self.BaseModelProgram.list,
              programFilterQuery
            );

            if (selectedProgram.length) {
              initialAwardDate = new Date(selectedProgram[0].InitialAwardDate);
            }

            //Validation moved to page load
            // if (isNullOrUndefined(initialAwardDate)) {
            //   localBuyoutData.ConvertToTreasury = "Yes";
            // } else if (
            //   self.getDateDiffinDays(partnerTermDate, initialAwardDate) < 365
            // ) {
            //   localBuyoutData.ConvertToTreasury = "No";
            // } else {
            //   localBuyoutData.ConvertToTreasury = "Yes";
            // }

            localBuyoutData.Unit = grdDataItem.AwardedUnits;
            localBuyoutData.VestedUnit = grdDataItem.VestedUnits;
            localBuyoutData.RetainedUnit = grdDataItem.UnitsToBeRetained;
            localBuyoutData.ForfeitedUnit = grdDataItem.UnitsToBeForfeited;
            localBuyoutData.AmountPaid = grdDataItem.AmountPaid;
            localBuyoutData.Id = grdDataItem.Id;
            localBuyoutData.VestingLogged = "Completed";

            self.saveBuyoutData.push(localBuyoutData);
          }
        });
      }
      if (self.saveBuyoutData.length > process.env.VUE_APP_ApprovalLimitCount) {
        this._AlertPopup(
          `You can only Approve ${process.env.VUE_APP_ApprovalLimitCount} records at a time`,
          "info"
        );
        return;
      }
      if (self.saveBuyoutData.length > 0) {
        var updateObject = {
          Buyout: {
            config: self.BaseModelBuyout,
            updateData: self.saveBuyoutData
          }
        };

        let response = await this._ConfirmationPopup(
          "This will approve buyout for selected program(s). Are You Sure? ",
          "Confirm"
        );
        console.log(updateObject.Buyout.config.list);
        if (response.value) {
          // let loader = this.$loading.show();
          self._APICrudPopup("APICrudpopup");
          self.saveBuyoutData.forEach(Buyout => {
            let TransactionBuyout = {};
            TransactionBuyout.BusinessEvent = "Forfeiture";
            TransactionBuyout.ProgramId = Buyout.ProgramId;
            TransactionBuyout.UnitClass = Buyout.UnitClass;
            TransactionBuyout.UnitType = Buyout.UnitType;
            TransactionBuyout.UnitPool = Buyout.UnitPool;
            TransactionBuyout.Unit = -1 * Buyout.ForfeitedUnit;
            TransactionBuyout.VestingType = Buyout.VestingType;
            TransactionBuyout.TransactionDate = !isNullOrUndefined(
              this.displayFields.TerminationDate
            )
              ? new Date(this.displayFields.TerminationDate)
              : null;
            TransactionBuyout.PartnerId = Buyout.PartnerId;
            TransactionBuyout.TransactionId = Buyout.Id;
            TransactionData.push(TransactionBuyout);
            if (Buyout.ConvertToTreasury.toLowerCase() == "yes") {
              let TransactionTreasury = _.clone(TransactionBuyout);
              TransactionTreasury.PartnerId = 1;
              TransactionTreasury.Unit = -1 * TransactionTreasury.Unit;
              TransactionData.push(TransactionTreasury);
            }
          });

          let TransactionCreateObject = {
            TransactionLog: {
              config: BaseModelTransactionLog,
              createData: TransactionData
            }
          };

          try {
            let createTrasactionResponse = null;
            let updateResponse = await self.UpdateAllItems(updateObject);
            if (updateResponse) {
              createTrasactionResponse = await self.CreateAllItems(
                TransactionCreateObject
              );
            }
            if (
              createTrasactionResponse &&
              process.env.VUE_APP_BusinessEventApproval == "true"
            ) {
              let runningTotalResponse = await this._RunningTotalEvent(
                TransactionData,
                true,
                true,
                false
              );
              console.log("runningTotalResponse", runningTotalResponse);
            }
            self.refreshGrid();
            self._AlertPopup("Buyout approved successfully!", "success");
          } catch (error) {
            self._AlertPopup("Some Error Occurred!", "info");
          }
        }
      } else {
        this._AlertPopup("Please select atleast one pending program.", "info");
      }
    },

    UpdateBuyoutDetailMasterData: function(fromFilter, filterMasterData) {
      const self = this;
      if (fromFilter == true) {
        self.BuyoutDetailMasterData = filterMasterData;
      } else {
        self.BuyoutDetailMasterData = $("#buyoutProgramDetailGrid")
          .data()
          .kendoGrid.dataSource.data();
      }
      self.gridColumnNonEditable();
    },

    // Grid search
    filterGrid: function() {
      const self = this;
      const currentMasterdata = self.BuyoutDetailMasterData;

      let filteredData = self._filterGrid(
        self.BuyoutDetailMasterData,
        self.SearchBuyout.SearchData
      );

      $("#buyoutProgramDetailGrid")
        .data("kendoGrid")
        .dataSource.data(filteredData);
      self.UpdateBuyoutDetailMasterData(true, currentMasterdata);
    },

    // Toolbar Submit Forfeiture butt, Generate Document
    BuyoutDetailToolBarClick(e) {
      const self = this;
      e.preventDefault();
      if (e.id === "btnBack") {
        self.backtoPartner();
      }
      if (e.id === "btnApproveBuyout") {
        self.approveBuyout();
      }
      if (e.id === "btnRefresh") {
        self.refreshGrid();
      }

      self._baseToolBarEvents(self.buyoutProgramDetailGridId, ...arguments);
    },

    refreshGrid: function() {
      this.getProgramGridData();
    },

    async getProgramGridData() {
      const self = this;
      self.ProgramDetailGridData = [];

      var response = self.withFilter(self.BaseModelBuyout.list);

      var filteredBuyoutData = await _.filter(response, function(obj) {
        return obj.PartnerId == self.partnerId;
      });
      console.log('   filteredBuyoutData ---->')
      console.log(filteredBuyoutData);

      //sum of awardunits
      var localProgramSumAwardedUnits = window.linq
        .from(filteredBuyoutData)
        .groupBy(
          "$.ProgramId",
          null,
          "{ProgramId: $, AmountPaidForProgram: $$.first(), SumofAwardedUnits: $$.sum('Number($.Unit)')}"
        )
        .toArray();
      // console.log(localProgramSumAwardedUnits);

      var localFirstAmountPaidForProgram = 0;

      //filteredBuyoutData = {program 1, unit 50}, {program 1, unit 50}, {program 2, unit 50}
      // localProgramSumAwardedUnits = {program 1, sum 100}, {program 2, sum 50}
      if (filteredBuyoutData.length && localProgramSumAwardedUnits.length) {
        for (var i = 0; i < filteredBuyoutData.length; i++) {
          var result = localProgramSumAwardedUnits.filter(function(obj) {
            return (
              obj.ProgramId.toString()
                .trim()
                .toLowerCase() ==
              filteredBuyoutData[i].ProgramId.toString()
                .trim()
                .toLowerCase()
            );
          })[0];

          if (result) {

            console.log('About to create ProgramDetailData....');
            console.log(' .... filteredBuyoutData[i] .....');
            console.log( filteredBuyoutData[i]);
            localFirstAmountPaidForProgram =
              result.AmountPaidForProgram.AmountPaidForProgram;
                                                                                     
            var ProgramDetailData = {};

            ProgramDetailData.Id = filteredBuyoutData[i].Id;
            ProgramDetailData.ProgramName = filteredBuyoutData[i].ProgramTitle;
            self.PartnerName = ProgramDetailData.PartnerName =
              filteredBuyoutData[i].PartnerFullName;

            ProgramDetailData.ProgramId = filteredBuyoutData[i].ProgramId;
            ProgramDetailData.PartnerId = filteredBuyoutData[i].PartnerId;
            ProgramDetailData.PartnerLeaveDate =
              filteredBuyoutData[i].PartnerLeaveDate;

            ProgramDetailData.UnitPool = filteredBuyoutData[i].UnitPool;
            ProgramDetailData.UnitType = filteredBuyoutData[i].UnitType;
            ProgramDetailData.UnitClass = filteredBuyoutData[i].UnitClass;
            ProgramDetailData.UnitPrice = filteredBuyoutData[i].UnitPrice;
            ProgramDetailData.VestingType = filteredBuyoutData[i].VestingType;
            ProgramDetailData.AwardedUnits = filteredBuyoutData[i].Unit;
            ProgramDetailData.AmountPaidForProgram = localFirstAmountPaidForProgram;
            ProgramDetailData.SumofAwardedUnits = result.SumofAwardedUnits;

            // ProgramDetailData.VestedPercent =
            //   filteredBuyoutData[i].VestedUnit / filteredBuyoutData[i].Unit;

            ProgramDetailData.UnitsToBeRetained = 0;

            //vested units + units to be retained
            ProgramDetailData.TotalUnitsToBeRetained =
              filteredBuyoutData[i].VestedUnit +
              ProgramDetailData.UnitsToBeRetained;

            //Awarded Units - Total Units to be retained
            ProgramDetailData.UnitsToBeForfeited =
              ProgramDetailData.AwardedUnits -
              ProgramDetailData.TotalUnitsToBeRetained;

            //Unit Price x Total Units to be retained:
            ProgramDetailData.AmountPayable =
              filteredBuyoutData[i].UnitPrice *
              ProgramDetailData.TotalUnitsToBeRetained;

            //unit price x units to be forfeited
            ProgramDetailData.AmountReceivable =
              filteredBuyoutData[i].UnitPrice *
              (filteredBuyoutData[i].Unit -
                ProgramDetailData.TotalUnitsToBeRetained);

            //Amount Paid For Program x (awarded units / (sum of awarded units for the program))
            ProgramDetailData.AmountPaid =
              localFirstAmountPaidForProgram *
              (filteredBuyoutData[i].Unit / result.SumofAwardedUnits);

            //max(0, amount paid - amount payable)
            ProgramDetailData.Buyout =
              ProgramDetailData.AmountPaid - ProgramDetailData.AmountPayable > 0
                ? ProgramDetailData.AmountPaid - ProgramDetailData.AmountPayable
                : 0;

            //max(0, amount payable - amount paid)
            ProgramDetailData.AmountOwedToPartnership =
              ProgramDetailData.AmountPayable - ProgramDetailData.AmountPaid > 0
                ? ProgramDetailData.AmountPayable - ProgramDetailData.AmountPaid
                : 0;

            //amount receivable - buyout
            ProgramDetailData.ContributionRelief =
              ProgramDetailData.AmountReceivable - ProgramDetailData.Buyout;

            //buyout - amount owed to partnership
            ProgramDetailData.NetPayout =
              ProgramDetailData.Buyout -
              ProgramDetailData.AmountOwedToPartnership;

            ProgramDetailData.Status = filteredBuyoutData[i].Status;
            ProgramDetailData.WorkflowStatus =
              filteredBuyoutData[i].WorkflowStatus;          


            console.log(" .... ProgramDetailData.....");
            console.log(ProgramDetailData);

            //buyout - Convert to Treasury
            //If diff between Initial Award Date & Termination Data < 365 then "NO" else "Yes"
            if(filteredBuyoutData[i].WorkflowStatus=="Approved")
            {
              ProgramDetailData.Treasury = filteredBuyoutData[i].ConvertToTreasury;
            }
            else
            {
              var tempHireDate = new Date();
              var tempVestStartDate = new Date();
              
              var tempPartnerTermDate = self.displayFields.TerminationDate;
              
              var partnerFilterQuery = { filter: "Id eq " + filteredBuyoutData[i].PartnerId}
              var selectedPartner = self.withFilter(self.BaseModelPartner.list, partnerFilterQuery);
              if(selectedPartner.length){
                tempHireDate = new Date(selectedPartner[0].HireDate);
              }
              if(isNullOrUndefined(tempHireDate) || self.getDateDiffinDays(tempPartnerTermDate, tempHireDate) < 365){
                ProgramDetailData.Treasury = "No";
                // ProgramDetailData.VestedUnits = 0;
                // ProgramDetailData.VestPercentage = 0;
              } 
              else 
              {
                var issuanceFilterQuery = { 
                  filter: "ProgramId eq " +  ProgramDetailData.ProgramId +" and ReceiverId eq " + ProgramDetailData.PartnerId
                }; 
                var selectedIssuance = self.withFilter(self.BaseModelIssuance.list, issuanceFilterQuery);
                console.log(selectedIssuance);
                if (selectedIssuance.length) {
                  selectedIssuance = selectedIssuance.filter(x=>x.VestingType == ProgramDetailData.VestingType && x.UnitClass == ProgramDetailData.UnitClass && x.UnitType == ProgramDetailData.UnitType);
                  if(selectedIssuance[0].VestingType == 'Standard'){
                    tempVestStartDate = new Date(selectedIssuance[0].VestStartDate);
                  } else {
                    tempVestStartDate = null;
                  }
                }
                if (isNullOrUndefined(tempVestStartDate) || self.getDateDiffinDays(tempPartnerTermDate, tempVestStartDate) < 365) {
                  ProgramDetailData.Treasury = "No";
                  // ProgramDetailData.VestedUnits = 0;
                  // ProgramDetailData.VestPercentage = 0;
                } else {
                  ProgramDetailData.Treasury = "Yes";
                }
              }
            }
             ProgramDetailData.VestedUnits = filteredBuyoutData[i].VestedUnit;
             ProgramDetailData.VestPercentage = filteredBuyoutData[i].VestPercentage;
            self.ProgramDetailGridData.push(ProgramDetailData);
          }
        }
        // console.log(self.ProgramDetailGridData);
      }
    }
    // Buyout Documnet Dropoff
    // BuyoutAttachment: function(e) {
    //   let self = this;
    //   e.preventDefault();
    //   const gview = window.$("#buyoutProgramDetailGrid").data("kendoGrid");
    //   const dataItem = gview.dataItem(window.$(e.currentTarget).closest("tr"));

    //   this.selectedBuyout={...dataItem};

    //   this.selectedBuyout.PartnerTitle=dataItem.PartnerName,
    //   this.selectedBuyout.PartnerId=dataItem.PartnerId
    //   this.selectedBuyout.ProgramTitle=dataItem.ProgramName
    //   this.selectedBuyout.ProgramId=dataItem.ProgramId
    //   this.selectedBuyout.TransactionID=dataItem.Id
    //   this.selectedBuyout.BusinessEvent="Buyout"

    //   this.filterCondition.filter = `BusinessEvent eq 'Buyout' and TransactionID eq ${
    //     dataItem.Id
    //   }`;

    //   this.$refs.buyoutDocument.$refs.buyoutDocumentMgr.resetDropZoneGrid();
    //   window.$("#docModal").modal("toggle");
    // }
  }
};
</script>
<style>
.disableRowCells {
  opacity: 0.7;
  pointer-events: none;
}
</style>